import http, { cachedHttp } from "./httpService";

const apiEndPoint = "/globalstreamconfigs/";

function getUrl() {
  return `${apiEndPoint}`;
}

export function getGlobalStreamConfigs() {
  return http.get(apiEndPoint);
}

export function getGlobalStreamConfigsFull() {
  return cachedHttp.get(`${apiEndPoint}?full=true`);
}

export function updateGlobalTargetRates(globalTargetRates) {
  return http.patch(getUrl(), {
    global: {
      global_target_rates: globalTargetRates,
    },
  });
}

export function updateCashierConfig(cashier) {
  return http.patch(getUrl(), {
    global: {
      cashier,
    },
  });
}
